import { request } from '@/sdk/oauth'

export function matchCaregiverProfiles(payload) {
  return request
    .post('caregiver/profiles', payload)
    .then(response => response.data)
    .catch(() => null)
}

export function matchCaregiversByPostcode(postcode) {
  return request
    .get(`customer/caregiver/list/${postcode}`)
    .then(response => response.data)
}

export function submitPostcode(payload) {
  return request
    .post('customer/post-code-match', payload)
    .then(response => response.data)
    .catch(error => error)
}
